/**
 * Where a referral link sends the visitor.
 *
 * - `app`: the marketing site — the general Autoclipper funnel.
 * - `viralize`: the Viralize em 4 Semanas landing page
 *   (`../human-touch-clips`), whose guest checkout sells the course to
 *   logged-out visitors.
 */
export type ReferralDestination = 'app' | 'viralize';

const REFERRAL_BASES: Record<ReferralDestination, string> = {
  app: 'https://autoclipper.live/a/',
  viralize: 'https://viralize.autoclipper.live/a/',
};

/**
 * The user's shareable referral link. Both destinations expose the same
 * `/a/<code>` short link: it 302s to `/?a=<code>`, the landing root stores the
 * code, and the next CTA forwards it — to the app's signup on the marketing
 * site (see site-novo-vers-o-oficial src/routes/a.$code.tsx), or to the course
 * purchase on the Viralize landing (human-touch-clips src/routes/a.$code.tsx),
 * which sends it as `affiliateCode` so the sale is attributed at purchase time.
 *
 * This is the single place the app builds those URLs.
 */
export function buildReferralUrl(code: string, destination: ReferralDestination = 'app'): string {
  return `${REFERRAL_BASES[destination]}${code.trim().toLowerCase()}`;
}
